// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_Q_-","cls2":"AuthorPopover-cls2_YkG AuthorPopover-cls1_Q_-"};